import React, { useEffect, useState } from 'react';
import './common.css';
import './Login.css';
import StickyHeader from './StickyHeader';
import { BarLoader, BeatLoader } from 'react-spinners';
import { FaCheckCircle, FaClock, FaQuestionCircle } from 'react-icons/fa';


const EmailDB = () => {
  const [loader, setLoader] = useState(false);
  const [offset, setOffset] = useState(0);
  const [emails, setEmails] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const [sendProgress, setSendProgress] = useState(false);
  
  const fetchEmails = async () => {
    if (loader || !hasMore) return;

    setLoader(true);
    try {
      const response = await fetch('https://promo.myservicecircle.app/webservice/fetchEmails.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ offset })
      });

      const responseData = await response.json();
      //console.log(JSON.stringify(responseData));
      if (responseData.success == 1 && Array.isArray(responseData.database)) {
        setEmails(prev => [...prev, ...responseData.database]);
        setOffset(prev => prev + responseData.database.length);
        setHasMore(responseData.has_more);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 10 >=
        document.documentElement.scrollHeight
      ) {
        fetchEmails();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [offset, hasMore, loader]);

  // Initial fetch
  useEffect(() => {
    fetchEmails();
  }, []);

  const handleSendEmail = async (id) => {
  setSendProgress(true);

  try {
    const response = await fetch('https://promo.myservicecircle.app/webservice/sendEmail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: id })
    });

    const responseData = await response.json();
    console.log(JSON.stringify(responseData));

    if (responseData.success === 1 && responseData.sender) {
      const { id: sender_id, name, email_address } = responseData.sender;

      setEmails(prev =>
        prev.map(item =>
          item.id === id
            ? {
                ...item,
                status: 1,
                sent_by: sender_id,
                sender: {
                  id: sender_id,
                  name: name,
                  email_address: email_address
                }
              }
            : item
        )
      );
    } else {
      alert(responseData.message || "Email send failed");
    }

  } catch (error) {
    console.log(error.message);
    //alert("Error: " + error.message);
  } finally {
    setSendProgress(false);
  }
};

  return (
    <>
      <StickyHeader />
      <div style={{ padding: 20 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
  <thead>
    <tr style={{ backgroundColor: '#f0f0f0' }}>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>ID</th>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>Company</th>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>Email</th>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>Status</th>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>Sent Using</th>
      <th style={{ padding: 10, border: '1px solid #ccc' }}>Action</th>
    </tr>
  </thead>
  <tbody>
    {emails.map((email, idx) => (
      <tr key={idx}>
        <td style={{ padding: 10, border: '1px solid #ccc' }}>{email.id}</td>
        <td style={{ padding: 10, border: '1px solid #ccc' }}>{email.company}</td>
        <td style={{ padding: 10, border: '1px solid #ccc' }}>{email.email}</td>
        <td style={{ padding: 10, border: '1px solid #ccc', textAlign: 'center' }}>
          {parseInt(email.status) === 1 ? (
            <FaCheckCircle color="green" />
          ) : (
            <FaClock color="#999" />
          )}
        </td>
        <td style={{ padding: 10, border: '1px solid #ccc', textAlign: 'center' }}>
          {parseInt(email.status) === 1 ? email.sender.name : <FaQuestionCircle color="#999" />}
        </td>
        <td style={{ padding: 10, border: '1px solid #ccc', textAlign: 'center' }}>
          {sendProgress ?
            <>
            <BarLoader size={20} color='green' />
            </>
            :
            <>
            <button
            onClick={() => handleSendEmail(email.id)}
            disabled={parseInt(email.status) === 1}
            style={{
              padding: '6px 12px',
              backgroundColor: parseInt(email.status) === 1 ? '#ccc' : '#2f80ed',
              color: '#fff',
              border: 'none',
              borderRadius: 5,
              cursor: parseInt(email.status) === 1 ? 'not-allowed' : 'pointer'
            }}
          >
          
            Send
          </button>
            </>
          }
        </td>
      </tr>
    ))}
  </tbody>
</table>


        {loader && (
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <BeatLoader />
          </div>
        )}

        {!hasMore && !loader && (
          <div style={{ textAlign: 'center', color: '#888', marginTop: 20 }}>
            No more data to load.
          </div>
        )}
      </div>
    </>
  );
};

export default EmailDB;
